module.exports = __webpack_public_path__ + "static/media/GNT.a8ca4977.png";